
import Link from 'next/link';
import { Box, Card, CardContent, CardMedia, CardActionArea, Typography,  Stack } from '@mui/material';
import {
    Col,
} from 'antd';
import dayjs from 'dayjs'

const ArticleItem = ({ item, locale }: any) => {
    const { news_Images, news_ID } = item
    const lng = locale.toUpperCase()
    let imageUrl = undefined
    const defaultImage = '/assets/single-logo.png'
    if (news_Images) {
        //imageUrl = `${process.env.REACT_APP_SELLER_SERVICE_API_BASE}/article/${news_ID}/image/${item.news_Images || ''}`;
        imageUrl = `https://cdn.9asset.com/download/article_image/${news_ID}/${item.news_Images}`
        imageUrl = imageUrl.replace('https://cdn.9asset.com/', 
            `https://imgproxy-lrq33qbvfq-de.a.run.app/insecure/rs:fit:360:240:no:0/plain/gs://9asset-storage/`) + '@webp'
    } else {
        imageUrl = defaultImage
    }
    const title = item[`news_Title_${lng}`] || item[`news_Title_TH`]

    return (
        <Col xs={24} sm={12} md={12} lg={8} xl={8} key={news_ID}>
            <Card>
                <CardActionArea>
                    <Link legacyBehavior href={`/article/${news_ID}/${title}`} passHref>
                        <a>
                            <CardMedia
                                component="img"
                                sx={{ width: 'auto', maxWidth: '100%', height: '200px', objectFit: 'cover', margin:'auto' }}
                                alt={title || ''}
                                image={imageUrl || ''}
                                onError={(e: any) => {
                                    e.target.src = defaultImage;
                                }}
                                
                                />
                           

                            <CardContent>
                                <Typography 
                                    variant='subtitle1'
                                    height={60}
                                    sx={{
                                        display: '-webkit-box',
                                        overflow: "hidden",
                                        WebkitLineClamp: 2,
                                        WebkitBoxOrient: 'vertical',
                                        textOverflow: 'ellipsis'
                                    }}
                                >
                                    {title}
                                </Typography>


                                <Typography variant="subtitle2" color="text.secondary"  height={100}
                                    sx={{
                                        display: '-webkit-box',
                                        overflow: "hidden",
                                        WebkitLineClamp: 4,
                                        WebkitBoxOrient: 'vertical',
                                        textOverflow: 'ellipsis'
                                    }}
                                >
                                    {item[`news_Des_${lng}`] || item[`news_Des_TH`]}
                                </Typography>

                                <Stack direction="row" spacing={2} sx={{ marginBottom: 1 }}>
                                    <Typography variant="subtitle2" display="block" gutterBottom >
                                        {item[`category_Name_${lng}`] || item[`category_Name_TH`]} {"  "}
                                    </Typography>
                                    <Typography variant="subtitle2" display="block" gutterBottom>
                                        {dayjs(new Date(item.news_Date)).format('DD.M.YYYY HH:mm')}
                                    </Typography>
                                </Stack>

                            </CardContent>
                        </a>
                    </Link>
                </CardActionArea>
            </Card>
        </Col>
    )
}

export default ArticleItem
